import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { DepartmentDetailView } from '../models/department-detail-view.model';
import { GetDepartmentDetail_department } from '../queries/generated/GetDepartmentDetail';
import * as DepartmentDetailActions from './department-detail.actions';

export const departmentDetailFeatureKey = 'departmentDetail';

export interface State {
   department: DepartmentDetailView | null;
   callState: CallState;
   currentDepartmentId: number | null;
}

export const initialState: State = {
   callState: LoadingState.Init,
   currentDepartmentId: null,
   department: null,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(DepartmentDetailActions.departmentDetailLoad, DepartmentDetailActions.departmentDetailCancel, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         department: null,
      };
   }),
   on(DepartmentDetailActions.loadDepartmentDetailSuccess, (state, action) => {
      const department: GetDepartmentDetail_department = action.data;
      return {
         ...state,
         callState: LoadingState.Loaded,
         department: {
            ...department,
         },
      };
   }),
   on(DepartmentDetailActions.loadPageNoDepartment, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(DepartmentDetailActions.loadDepartmentDetailFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(DepartmentDetailActions.saveDepartmentDetail, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(DepartmentDetailActions.updateDepartmentId, (state, { departmentId }) => {
      return {
         ...state,
         currentDepartmentId: departmentId,
      };
   }),
   on(
      DepartmentDetailActions.saveDepartmentDetailFailure,
      DepartmentDetailActions.departmentDetailAccessDenied,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   )
);
